const getEventInfo = (type = "") => {
  return {
    eventAction: `my account:account settings:${type}`,
    eventName: `my account:account settings:${type}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: type,
    internalLinkPosition: "my account:account settings",
    internalLinkType: "my account:addresses",
    internalLinkZoneName: "my account:account settings",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
}

export const addAnalyticsForAddAddresses = (type = "") => {
  const { adobeDataLayer: { getState } = {} } = window
  const page = getState?.("page") || {}
  const eventInfo = getEventInfo(type)

  window?.adobeDataLayer?.push({
    event: "cmp:click",
    eventInfo,
    page,
  })
}
export const addDataLayerEditAddressClose = () => {
  const { adobeDataLayer: { getState } = {} } = window
  const page = getState?.("page") || {}
  const eventInfo = {
    eventAction: "my account:account settings:modal:add address:close",
    eventName: "my account:account settings:modal:add address:close",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "close",
    internalLinkPosition: "my account:account settings",
    internalLinkType: "my account:addresses",
    internalLinkZoneName: "my account:account settings:modal:add address",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  window?.adobeDataLayer.push({
    event: "cmp:click",
    eventInfo,
    page,
  })
}
